/** biome-ignore-all lint/correctness/useUniqueElementIds: deprecated */ /** biome-ignore-all lint/security/noDangerouslySetInnerHtml: deprecated */ /** biome-ignore-all lint/a11y/useAltText: deprecated */ 'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Loader } from '@lichtblick/ui-components';
import classNames from 'classnames';
import Script from 'next/script';
import { useState } from 'react';
import styles from './gapminder.module.scss';
export const Gapminder = ({ objects })=>{
    const gapminderAssetsPath = 'https://static.lichtblick.de/snowflakes/nextjs/gapminder';
    const [isLoading, setIsLoading] = useState(true);
    const parsedObjects = typeof objects === 'object' ? objects : objects && JSON.parse(objects);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Script, {
                onReady: ()=>{
                    setIsLoading(false);
                    document.dispatchEvent(new Event('initSnowflakeGapminder'));
                },
                src: `${gapminderAssetsPath}/main.59a9f71570beec099f0a692330de5029.js`
            }),
            /*#__PURE__*/ _jsx("link", {
                href: `${gapminderAssetsPath}/styles.59a9f71570beec099f0a692330de5029.css`,
                rel: "stylesheet"
            }, "gapminder-snowflake-css"),
            /*#__PURE__*/ _jsx("link", {
                href: "https://static.lichtblick.de/react-components/hugo-apps.css",
                rel: "stylesheet"
            }, "hugo-apps-styles"),
            /*#__PURE__*/ _jsxs("div", {
                className: classNames('snowflake-gapminder', 'gapminder', 'theme--faded-gray', 'theme--light', styles.container),
                id: "gapminder",
                children: [
                    isLoading && /*#__PURE__*/ _jsx("div", {
                        className: styles['loader-container'],
                        children: /*#__PURE__*/ _jsx(Loader, {})
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "slides space__ptd--xl space__ptm--m",
                        children: parsedObjects?.slides.map((slide, i)=>/*#__PURE__*/ _jsx("div", {
                                className: `slide${i > 0 ? ' right' : ''}`,
                                id: `slide${i}`,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "gapminder-inner",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "icon",
                                            id: "gapminder_icon",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: `${gapminderAssetsPath}${slide.icon}`
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "a-chip accent__bg",
                                            children: "Was denkst du?"
                                        }),
                                        /*#__PURE__*/ _jsx("h2", {
                                            className: "a-headline a-headline--m question space__pbd--s space__pbm--s",
                                            "data-error": slide.answer_error,
                                            "data-success": slide.answer_success,
                                            children: slide.question
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "space__pbd--s space__pbm--s",
                                            dangerouslySetInnerHTML: {
                                                __html: slide.answer
                                            }
                                        }),
                                        Boolean(slide.answer) && /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "answered space__pbd--l space__pbm--m",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "button",
                                                            "data-answer": "0",
                                                            "data-result": slide.result_1,
                                                            children: slide.button_1
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "button",
                                                            "data-answer": "1",
                                                            "data-result": slide.result_2,
                                                            children: slide.button_2
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "button",
                                                            "data-answer": "2",
                                                            "data-result": slide.result_3,
                                                            children: slide.button_3
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("button", {
                                                    className: "a-button a-button--link gapminder_next space__pbd--xl space__pbm--m",
                                                    type: "button",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: "Nächste Frage"
                                                    })
                                                })
                                            ]
                                        }),
                                        !slide.answer && /*#__PURE__*/ _jsxs("div", {
                                            className: "answers",
                                            children: [
                                                /*#__PURE__*/ _jsx("button", {
                                                    className: "a-button a-button--outline space__pbm--s",
                                                    "data-answer": "0",
                                                    type: "button",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: slide.button_1
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("button", {
                                                    className: "a-button a-button--outline space__pbm--s",
                                                    "data-answer": "1",
                                                    type: "button",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: slide.button_2
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("button", {
                                                    className: "a-button a-button--outline space__pbm--s",
                                                    "data-answer": "2",
                                                    type: "button",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: slide.button_3
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, slide.question + slide.answer))
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=Gapminder.js.map